import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import { Container } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom';

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = dispatch => ({

});

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

class RegisterConfirmation extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      username: "",
      pin: null,
      update: false,
      shouldNavigate: false,
      token: null,
    };

  }
  componentDidMount = () => {
    const path = window.location.pathname;
    const pathParts = path.split('/');
    const token = pathParts[1];
    this.setState({ token })

    if (!this.state.update && this.props.auth.register !== undefined && this.props.auth.register !== null) {
      this.setState({
        username: this.props.auth.register.username,
        pin: this.props.auth.register.pin,
        update: true
      })
    } else {
      setTimeout(() => {
        this.setState({ shouldNavigate: true });
      }, 1000)
    }
  }

  render() {
    return <Fragment>
      <div className="color-body">
        <NavbarComp bgblue={true} />
        <div className="page-sections">
          <div className='register-confirm-wrap'>
            <Container>
              <div className='register-confirm-contents'>
                <h2 className='main-title-style'>THANK YOU</h2>
                <div className='registered-details'>
                  <p>Your login details are</p>
                  <span>{this.state.username}</span>
                  <p>(your initials and date of birth) and</p>
                  <span>PIN {this.state.pin}</span>
                </div>
                <h2 className='main-title-style'>WHAT HAPPENS NEXT</h2>
                <ul>
                  <li><span>1</span>Answer a few quick questions</li>
                  <li><span>2</span>Option to complete a sleep health self-assessment and receive a personalised report</li>
                  <li><span>3</span>Do at least two alertness tests to create a baseline score</li>
                </ul>
                <a href="/onboarding-process" rel="nofollow"><button>START</button></a>
              </div>
            </Container>
          </div>
        </div>
      </div>
      
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={"/" + this.state.token + "/register"} />
    </Fragment>
  }
}

RegisterConfirmation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(RegisterConfirmation);
